<template>
  <div class="q-mb-md">
    <draggable
      v-if="value.length"
      :list="value"
      itemKey="_id"
      v-bind="{
        animation: 200,
        group: 'welcome',
        disabled: false,
      }"
      @change="(evt) => onDragEnd(evt, value)"
      handle=".cursor-move"
      :component-data="{
        type: 'transition-group',
        name: 'drag-area',
        class: 'q-list q-list--dense q-list--separator q-py-sm',
      }"
      :forceFallback="true"
      fallbackClass="dragging-item"
    >
      <template #item="{ element: conditionOr, index }">
        <div class="bg-white">
          <q-list class="q-pb-sm">
            <q-item class="q-px-none q-mr-md" style="border: 1px solid black; border-radius: 8px; padding: 16px">
              <q-item-section>
                <div class="row items-center justify-between">
                  <div class="text-bold">グループ{{ index + 1 }}</div>
                  <q-btn
                    size="sm"
                    color="red"
                    label="削除"
                    outline
                    @click="handleDeleteCondition(index)"
                    v-if="value.length > 1 && !isDeleteFirst"
                  />
                </div>
                <div class="horizontal-line q-my-sm"></div>
                <ConditionAnd v-model="conditionOr.conditions" />
              </q-item-section>
            </q-item>
          </q-list>

          <div class="row items-center q-pb-sm q-pr-md" v-if="value.length - 1 === index">
            <div class="col horizontal-line"></div>
            <div class="or-buttons-block">
              <q-btn
                size="sm"
                flat
                color="black"
                icon="add"
                @click="handleAddCondition(index)"
                label="条件グループ追加（OR）"
                class="full-width"
              />
            </div>
            <div class="col horizontal-line"></div>
          </div>
          <div class="row items-center q-pb-sm" v-else>OR</div>
        </div>
      </template>
    </draggable>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { maska } from 'maska'
import draggable from 'vuedraggable'
import { calcOrderingDragend } from '@/utils/helpers'
import ConditionAnd from '@/components/common/condition-setting/ConditionAnd.vue'
import type { IAudienceBuilderCondition } from '@/utils/types'
import { v4 as uuidv4 } from 'uuid'
@Options({
  components: { draggable, ConditionAnd },
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class ConditionOr extends Vue {
  @Prop({ default: [] })
  modelValue!: IAudienceBuilderCondition[]

  @Prop()
  isDeleteFirst!: boolean

  get value() {
    return this.modelValue
  }

  set value(value: IAudienceBuilderCondition[]) {
    this.$emit('update:modelValue', value)
  }

  @Watch('modelValue', { immediate: true })
  showDefault() {
    if (this.value.length === 0) {
      this.handleAddCondition(0)
    }
  }

  handleAddCondition(index: number): void {
    const newCondition: IAudienceBuilderCondition = {
      _id: uuidv4(),
      conditions: [
        {
          _id: uuidv4(),
          type: '',
          data_id: [],
          column_name: '',
          text: '',
          filter: 'include',
          date: '',
        },
      ],
    }
    if (this.value) {
      this.value.splice(index + 1, 0, newCondition)
    }
  }

  handleDeleteCondition(index: number): void {
    if (this.value) {
      this.value.splice(index, 1)
    }
  }

  // eslint-disable-next-line
  async onDragEnd(evt: any, finalList: IAudienceBuilderCondition[]) {
    if (!evt.moved) {
      return
    }

    const record = evt.moved.element
    calcOrderingDragend(record, finalList)
  }
}
</script>

<style scoped lang="scss">
.or-buttons-block {
  width: 100%;
  border: 1px dotted black;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  gap: 8px;
  // padding: 8px;
}
</style>
